
const init = (button) => {
	const submenu = button.closest('.site-menu-desktop__sub')
	const topLevelLink = submenu.parentNode.querySelector('.site-menu-desktop__link')

	button.addEventListener('click', () => {
		topLevelLink.classList.add('site-menu-desktop__link--hide-menu')
		
		setTimeout(() => {
			topLevelLink.classList.remove('site-menu-desktop__link--hide-menu')	
		}, 25)
	})
}

export default () => {
	const closeButtons = [...document.querySelectorAll('.site-menu-desktop__sub__close')]
	closeButtons.map(init)
}